import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import axios from "axios";
import "./styles.css";

// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  TablePagination,
  Box
} from '@mui/material';

// components
import Scrollbar from '../components/scrollbar';
import CompanyCreate from '../pages/CompanyCRUDPages/create';
import ZoneListforCompany from './ZoneListforCompany';
import WorkerListforCompany from './WorkerListforCompany';

const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

export default function CompaniesListAll() {
  const [companyId, setCompanyId] = useState('');
  const [showbuildingcreate, setShowBuildingCreate] = useState(false);
  const [showzones, setShowzones] = useState(false);
  const [showworkers, setShowworkers] = useState(false);
  const [members, setMembers] = useState([]);
  const [dataloaded, setDataLoaded] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const { user: currentUser } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!dataloaded) getAllCompanies();
  }, [dataloaded]);

  const getAllCompanies = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/companies`);
      setMembers(response.data);
      setDataLoaded(true);
    } catch (err) {
      console.log("error fetching companies", err);
    }
  };

  if (!currentUser) return <Navigate to="/login" />;

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      <Helmet>
        <title>Pametna rasvjeta</title>
      </Helmet>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // 🔥 OVO
        backgroundColor: '#001536'
      }}>
        <Box sx={{ flex: 1, p: 2 }}>
          <Container maxWidth={false} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

            {/* ADD COMPANY */}
            <Button
              onClick={() => setShowBuildingCreate(!showbuildingcreate)}

              sx={{
                minWidth: 100,
                width: 'fit-content',
                backgroundColor: '#001B44',
                color: '#ff9800',                // 🔥 tekst orange
                border: '1px solid #ff9800',     // 🔥 border orange
                '&:hover': {
                  backgroundColor: '#001B44',
                  border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                  color: '#ffa726'
                }
              }}
            >
              Dodaj partnersku firmu
            </Button>

            {showbuildingcreate && (
              <CompanyCreate
                onSuccess={() => {
                  setShowBuildingCreate(false);
                  setDataLoaded(false);
                }}
              />
            )}

            <Typography sx={{ color: '#ff9800', fontSize: '1.3rem', fontWeight: 600 }}>
              Pregled partnera
            </Typography>

            <Card sx={{ backgroundColor: '#00122E', color: '#ff9800', p: 2 }}>

              <Scrollbar>
                <Stack spacing={2}>
                  {members
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <Card
                        key={row.id}
                        sx={{
                          p: 2,
                          backgroundColor: '#00122E',
                          color: '#ff9800',
                          borderRadius: '10px',
                          overflow: 'hidden',
                          border: 'none',
                          boxShadow: 'inset 0 0 0 2px rgba(255,255,255,0.15)'
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 4,
                            flexWrap: { xs: 'wrap', md: 'nowrap' }
                          }}
                        >
                          {/* INFO */}
                          <Stack sx={{ flex: 2 }} spacing={0.8}>
                            <Typography sx={{ fontSize: '1.3rem', fontWeight: 700 }}>
                              {row.name}
                            </Typography>

                            <Typography>📍 {row.address}</Typography>
                            <Typography>📧 {row.email}</Typography>
                            <Typography>📞 {row.phoneNumber}</Typography>
                          </Stack>

                          {/* ACTIONS - DESNO DOLE */}
                          <Stack
                            sx={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'flex-end',
                              alignItems: 'flex-end'
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                gap: 1,
                                alignItems: 'center'
                              }}
                            >
                              <Button
                                sx={{
                                  minWidth: 100,
                                  backgroundColor: '#001B44',
                                  color: '#ff9800',                // 🔥 tekst orange
                                  border: '1px solid #ff9800',     // 🔥 border orange
                                  '&:hover': {
                                    backgroundColor: '#001B44',
                                    border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                                    color: '#ffa726'
                                  }
                                }}
                                onClick={() => navigate("/company/update", { state: row })}
                              >
                                Uredi
                              </Button>

                              <Button
                                sx={{
                                  minWidth: 100,
                                  backgroundColor: '#001B44',
                                  color: '#ff9800',                // 🔥 tekst orange
                                  border: '1px solid #ff9800',     // 🔥 border orange
                                  '&:hover': {
                                    backgroundColor: '#001B44',
                                    border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                                    color: '#ffa726'
                                  }
                                }}
                                onClick={() => {
                                  setCompanyId(row.id);
                                  setShowzones(!showzones);
                                  setShowworkers(false);
                                }}
                              >
                                Zone
                              </Button>

                              <Button
                                sx={{
                                  minWidth: 100,
                                  backgroundColor: '#001B44',
                                  color: '#ff9800',                // 🔥 tekst orange
                                  border: '1px solid #ff9800',     // 🔥 border orange
                                  '&:hover': {
                                    backgroundColor: '#001B44',
                                    border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                                    color: '#ffa726'
                                  }
                                }}
                                onClick={() => {
                                  setCompanyId(row.id);
                                  setShowworkers(!showworkers);
                                  setShowzones(false);
                                }}
                              >
                                Workers
                              </Button>
                            </Box>
                          </Stack>
                        </Box>
                      </Card>
                    ))}
                </Stack>
              </Scrollbar>
            </Card>

            {showzones && <ZoneListforCompany companyId={companyId} />}
            {showworkers && <WorkerListforCompany companyId={companyId} />}

          </Container>
        </Box>
      </Box >
    </>
  );
}